// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-slider {
    width: 100%;
    max-width: 20vw;
    height: 100%;
    position: relative;
}

.custom-slider .text-label {
    border: none;
    padding: 2%;
    height: 50%;
}

.custom-slider .slider-container {
    height: 50%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.custom-slider .slider-container:hover {
    cursor: pointer;
}

.custom-slider .left-slider {
    position: absolute;
    left: 0;
    top: 60%;
    height: 30%;
    width: 3%;
    background-color: #efe9e9;
    border: 1px solid black;
    z-index: 20;
}

.custom-slider .left-slider-span {
    position: absolute;
    left: 0;
    top: 90%;
}

.custom-slider .right-slider {
    position: absolute;
    right: 0;
    top: 60%;
    height: 30%;
    width: 3%;
    background-color: #efe9e9;
    border: 1px solid black;
    z-index: 20;
}

.custom-slider .right-slider-span {
    position: absolute;
    right: 0;
    top: 90%;
}

.custom-slider .left-slider:hover, .right-slider:hover {
    cursor: pointer;
}

.custom-slider .left-slider.clicked, .right-slider.clicked {
    background-color: var(--link-active);
}

.custom-slider .slider-container .range {
    height: 50%;
    background-color: white;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
}

.custom-slider .slider-container .range:first-child {
    border-left: 1px solid black;
}

.custom-slider .slider-container .range:last-child {
    border-right: 1px solid black;
}

.custom-slider .slider-container .range.active{
    background-color: rgba(44, 202, 255, 0.17);
}`, "",{"version":3,"sources":["webpack://./src/components/CustomRangeSlider/CustomRangeSlider.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0CAA0C;AAC9C","sourcesContent":[".custom-slider {\n    width: 100%;\n    max-width: 20vw;\n    height: 100%;\n    position: relative;\n}\n\n.custom-slider .text-label {\n    border: none;\n    padding: 2%;\n    height: 50%;\n}\n\n.custom-slider .slider-container {\n    height: 50%;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.custom-slider .slider-container:hover {\n    cursor: pointer;\n}\n\n.custom-slider .left-slider {\n    position: absolute;\n    left: 0;\n    top: 60%;\n    height: 30%;\n    width: 3%;\n    background-color: #efe9e9;\n    border: 1px solid black;\n    z-index: 20;\n}\n\n.custom-slider .left-slider-span {\n    position: absolute;\n    left: 0;\n    top: 90%;\n}\n\n.custom-slider .right-slider {\n    position: absolute;\n    right: 0;\n    top: 60%;\n    height: 30%;\n    width: 3%;\n    background-color: #efe9e9;\n    border: 1px solid black;\n    z-index: 20;\n}\n\n.custom-slider .right-slider-span {\n    position: absolute;\n    right: 0;\n    top: 90%;\n}\n\n.custom-slider .left-slider:hover, .right-slider:hover {\n    cursor: pointer;\n}\n\n.custom-slider .left-slider.clicked, .right-slider.clicked {\n    background-color: var(--link-active);\n}\n\n.custom-slider .slider-container .range {\n    height: 50%;\n    background-color: white;\n    border-top: 1px solid black;\n    border-bottom: 1px solid black;\n}\n\n.custom-slider .slider-container .range:first-child {\n    border-left: 1px solid black;\n}\n\n.custom-slider .slider-container .range:last-child {\n    border-right: 1px solid black;\n}\n\n.custom-slider .slider-container .range.active{\n    background-color: rgba(44, 202, 255, 0.17);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
